module.exports = __webpack_public_path__ + "img/saturn5.d8747412.png";